import { Link } from 'react-router-dom';
import { ArrowRight } from './Icons.jsx';
import kunalPhoto from '../assets/kunal.png';
import kunalSig from '../assets/kunal-sig.png';

// A compact letter from Dr Kunal — adapts to where it's used (parents / teachers / etc.).
// Pass `children` for the body paragraphs.
export default function FounderNote({ kicker, title, children, ctaText = 'Read the full letter', ctaTo = '/about', accent = 'var(--brand-purple)' }) {
  return (
    <section style={wrap}>
      <div style={inner}>
        <div style={polaroidWrap} className="founder-note-polaroid">
          <div style={polaroid}>
            <img src={kunalPhoto} alt="Dr Kunal" style={polaroidImg} />
            <div style={polaroidCaption}>Dr Kunal</div>
          </div>
        </div>

        <div style={body}>
          {kicker && <div style={{ ...kickerStyle, color: accent }}>{kicker}</div>}
          {title && <h2 style={titleStyle}>{title}</h2>}
          <div style={paras}>
            {children}
          </div>
          <img src={kunalSig} alt="Dr Kunal signature" style={sigImg} />
          <div style={signoff}>
            <strong style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 14, color: 'var(--text)' }}>Dr Kunal</strong>
            <span style={{ color: 'var(--text-muted)', fontSize: 12.5, fontFamily: 'Montserrat, sans-serif' }}> · Founder, Medic Mind</span>
          </div>
          <Link to={ctaTo} style={{ ...ctaLink, color: accent }}>{ctaText} <ArrowRight width="14" height="14" /></Link>
        </div>
      </div>

      <style>{`
        @media (max-width: 720px) {
          .founder-note-polaroid { float: none !important; margin: 0 auto 18px !important; display: block; }
        }
      `}</style>
    </section>
  );
}

const wrap = {
  background: '#fdf8ef',
  backgroundImage: 'radial-gradient(circle at 12% 18%, rgba(124, 62, 175, 0.07), transparent 40%), radial-gradient(circle at 86% 90%, rgba(58, 184, 166, 0.08), transparent 50%)',
  borderRadius: 16,
  border: '1px solid rgba(35, 20, 63, 0.06)',
  padding: 'clamp(22px, 3.5vw, 36px) clamp(22px, 4vw, 40px)',
  marginBottom: 28,
  boxShadow: '0 12px 32px rgba(35, 20, 63, 0.08)'
};
const inner = { maxWidth: 720, margin: '0 auto', overflow: 'auto' };

const polaroidWrap = { float: 'right', margin: '2px -6px 14px 22px' };
const polaroid = {
  background: '#fff', padding: '8px 8px 10px',
  border: '1px solid rgba(0,0,0,0.05)',
  boxShadow: '0 14px 32px rgba(35, 20, 63, 0.18)',
  transform: 'rotate(3deg)'
};
const polaroidImg = { display: 'block', width: 140, height: 170, objectFit: 'cover' };
const polaroidCaption = { fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', marginTop: 6 };

const kickerStyle = { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.18em', fontFamily: 'Montserrat, sans-serif', marginBottom: 6 };
const titleStyle = { fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 'clamp(22px, 3.5vw, 28px)', fontWeight: 400, fontStyle: 'italic', color: 'var(--brand-deep)', margin: '0 0 16px', letterSpacing: '-0.01em', lineHeight: 1.2 };
const body = { };
const paras = { fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 16, lineHeight: 1.75, color: 'var(--text)' };
const sigImg = { display: 'block', maxWidth: 200, height: 'auto', marginTop: 6, marginBottom: 6, marginLeft: -6, transform: 'rotate(-2deg)' };
const signoff = { fontSize: 13, marginBottom: 14 };
const ctaLink = {
  display: 'inline-flex', alignItems: 'center', gap: 6,
  fontSize: 13.5, fontWeight: 700, textDecoration: 'none',
  fontFamily: 'Montserrat, sans-serif'
};
